export default "__VITE_ASSET__D8OsV3M8__"